import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import moment from 'moment-timezone';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventsModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedEventId: null,
            selectedClientId: null,
        }
    }

    handleTransferToEvent = (e) => {
        let events = this.props.events;
        let selectedEventId = parseInt(e.target.value);
        let selectedClientId;
        events.forEach((event) => {
            if (parseInt(event.id) === parseInt(e.target.value)) {
                selectedClientId = event.client_id;
            }
        })
        if (selectedEventId === 'undefined') {
            selectedEventId = null;
            selectedClientId = null;
        }
        this.setState({
            selectedEventId,
            selectedClientId,
        });
    }

    transferToEvent = () => {
        let selectedEventId = this.state.selectedEventId;
        let selectedClientId = this.state.selectedClientId;
        this.props.transferToEvent(selectedEventId, selectedClientId, 'Event Check');
        this.setState({
            selectedEventId: null,
            selectedClientId: null,
        });
    }

    toggleEventsModal = () => {
        this.setState({
            selectedEventId: null,
            selectedClientId: null,
        });
        this.props.toggleEventsModal();
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isEventsModalOpen} toggle={() => this.props.toggleEventsModal()}>
                    <ModalHeader toggle={() => this.props.toggleEventsModal()}>{strings.events}</ModalHeader>
                    <ModalBody className="text-left">
                        <p>{strings.description}</p>
                        <div className="showtix-form__select">
                            <select className="showtix-input"
                                onChange={(e) => this.handleTransferToEvent(e)}
                            >
                                <option value="undefined">{strings.select}</option>
                                {
                                    this.props.events.map((event, i) => <option key={i} value={event.id}>{event.name} - {event.id}</option>)
                                }
                            </select>
                        </div>

                        {/* this.props.events.map((event) => (
                            <React.Fragment>
                                <p>
                                    <button
                                        className="showtix-button showtix-background__primary-2"
                                        onClick={() => this.props.transferToEvent(event.id, event.client_id, 'Event Check')}
                                    >
                                        {event.name} - {event.id}
                                    </button>
                                </p>
                            </React.Fragment>
                        )) */}
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-2"
                            onClick={() => this.transferToEvent()}
                            disabled={!this.state.selectedEventId && !this.state.selectedClientId}
                        >
                            {strings.transfer}
                        </button>
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={() => this.toggleEventsModal()}
                        >{strings.cancel}</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

EventsModal.propTypes = {
    isEventsModalOpen: PropTypes.bool,
    toggleEventsModal: PropTypes.func,
    transferToEvent: PropTypes.func,
    events: PropTypes.array,
};

export default EventsModal;


// WEBPACK FOOTER //
// ./src/components/Payout/EventsModal/EventsModal.js